
export default {
  en: {
    1: 'Live',
    2: 'Videos',
    3: 'Tournaments',
    4: 'My Space',
    5: 'Feedback',
    6: 'Take part in the interaction',
    7: 'Tournament',
    8: 'Streamers',
    9: 'Playback',
    10: 'Wifi is not connected, cellular data usage will be charged',
    11: 'No live streams yet',
    12: 'K',
    13: 'Recommendation',
    14: 'Tournament',
    15: 'Official Livestream',
    16: 'Search',
    17: 'Common Questions',
    18: 'Describe your issue',
    19: 'Contact Information',
    20: 'Submit',
    21: 'Feedback',
    22: 'cancel',
    23: 'Show Less',
    24: 'Fill in the feedback',
    25: 'Please log in again',
    26: 'Please check your internet connection and try again',
    27: 'The feedback is only available for Live&Videos, not for in-game problems',
    //=============================
    28: 'Chat',
    29: 'Comment',
    30: 'Contest Guess',
    31: 'Spreading illegal or vulgar content will be banned',
    32: 'Block this person?',
    33: 'If you block this person, you won\'t be able to see their messages.',
    34: 'Block',
    35: '${name} has been blocked',
    36: 'Anonymous User',
    37: 'More',
    38: 'Hide replies',
    39: 'View ${count} replies',
    40: 'Odds in Automatic Odds Mode are calculated by system',
    41: 'Fold at ${time}',
    42: 'End',
    43: 'Folded',
    44: 'Placed Bet',
    45: 'Place Bet',
    46: 'I guess 【${option}】',
    47: 'Enter the Wager Amount',
    48: 'No Contest Guess Yet',
    49: 'Betting is over and contest guess is not allowed.',
    50: 'Cannot bet repeatedly',
    51: 'Click to enter',
    52: 'Say something',
    53: 'Anonymous',
    54: 'Send${wait}',
    55: 'Search',
    56: 'Filter',
    57: 'Reminder on',
    58: 'Set reminder',
    59: 'Report',
    60: 'Show More',
    61: 'Done',
    62: 'Check in',
    63: 'Contest Guess',
    64: 'Reminders',
    65: 'Subscriptions',
    66: 'Exchange Stores',
    67: 'Contest Guess Record',
    68: 'More',
    69: '【I guess ${option}】',
    70: 'Available',
    71: 'Your tokens are not enough to bet',
    72: 'Claim ${value} tokens',
    73: 'Maximum number of Subscriptions',
    74: 'Cannot bet repeatedly',
    75: 'GM Notice',
    76: 'Tipping',
    77: 'Enter the tipping amount',
    78: 'Tipping Successfully',
    79: 'Your tokens are insufficient to tip the streamer',
    //-----------
    80: 'Chart',
    81: 'Gift Points',
    82: 'Streamer',
    83: 'Audience',
    84: 'The chart is based on gift points accumulated by the streamer within a week. The more tokens audiences tip, the higher gift points streamers obtain .',
    85: 'The chart is based on tokens that the audience have tipped within a week',
    86: 'No subscription. Go to subscribe streamers!',
    87: 'No contest guess record yet.',

    //=======================
    88: 'No more contest guess record',
    89: 'Show More',
    90: 'Offline',
    91: 'Live Now',
    92: 'No Live Yet',
    93: 'You\'ll gain ${money} tokens after countdown',
    94: 'Please fill in the email address correctly',


    //===================兑换记录-弹窗
    200: '引換アイテム',
    201: '使用した予想コイン',
    202: '引換期間',

    //===================领取竞猜币-弹窗
    205: 'ゲームにログイン',
    206: '通常バトルに参加',
    207: 'フレンドと一緒に通常バトルに参加',
    208: 'シェアしたリンクでフレンドを招待',
    209: 'イベント情報をシェア',
    210: '予想コイン',
    211: '未達成',
    212: '受け取る',
    213: '受取済み',
    215: 'シェア',
    //===================顶部-领取竞猜币
    214: '予想コインをゲット',

    //===================竞猜记录
    220: '総資産',
    221: '${1}位',
    222: '回収率',
    223: '的中率',
    224: '【${1}】予想コイン${2}枚使用',
    225: '結果待ち...',
    226: '全部',
    227: '結果待ち',
    228: '試合結果',
    229: 'ランク外',//'ランキング外'
    230: '試合結果：【${1}】，予想コイン${2}（当時オッズ${3}）',
    231: '戻る',

    //===================竞猜页
    235: 'オッズ',
    236: '試合結果',
    237: '本予想は終了しました',
    238: 'ベットする',
    239: 'ベット済み',
    240: '${1}人参加済',
    241: '確 認',
    242: '試合予想',
    243: '予想コインが不足しています',
    245: '今すぐゲットへ',
    246: 'ベット受付終了まで${1}日${2}時間${3}分',
    247: '予想開始時間：${1}日${2}時',
    248: '予想受付時間外',
    249: '本試合の予想は${1} ${2}から参加解禁です',
    250: '本日',
    251: '${1}月${2}日',
    252: 'ベットする選択肢を選んでください',
    253: 'ベット完了！',
    254: '本試合は${1} ${2}より開催しますので、是非ご期待ください！',
    255: 'ベット済みです、試合観戦を楽しんでください！',
    256: '現在ベットできません',
    257: 'ベット受付終了まで${1}時間${2}分',//与246配对
    258: 'クイズ',

    //==============排行榜
    260: 'ランキング',
    261: 'プレイヤー',
    262: '回収率',
    263: '的中率',
    264: '総資産',
    265: '${1}位',
    266: '予想記録',
    267: '私',
    268: '予想履歴',
    269: 'ランキング外',

    //===============兑换商城
    270: '残り${1}/${2}回',
    271: 'サーバー限定${1}個',
    272: '引換',
    273: '予想コインを使用して、【${1}】を引き換 えますか？',
    274: '確 認',
    275: '予想コインが不足しています',
    276: '引き換え完了！',
    277: '報酬は24時間以内にゲーム内メールボックスに送付します。',
    278: '現在引換できません',
    279: '引換制限数量となりました',
    280: '兌換失敗',
    281: '${1}月${2}日 ${3}から引換可能',
    282: '予想コインをゲットしました',

    //===============gamble
    290: '全チームを確認',
    291: '引換履歴',
    292: '試合予想',
    293: '引換ショップ',
    294: '予想ランキング',
    295: '予想履歴',
    296: '(${1}未開始)',
    297: '(${1}予想中)',
    298: '(${1}配信中)',
    299: '(${1}終了済)',
    300: 'Quiz',//root顶部导航栏
    302: '確 認',
    303: '本大会は既に終了いたしました',
    304: '本試合の予想は${1}月${2}日${3}より開始します',

    301: 'イベント情報をシェア',//分享渠道选择

    //===================竞猜页2
    400: '大会情報',    
    401: '観戦する',
    402: '予想ヒント'
  },
  zht: {
    1: '直播',
    2: '視頻',
    3: '賽事',
    4: '個人中心',
    5: '反饋',
    6: '進入直播間，參與互動',
    7: '官方賽事',
    8: '人氣主播',
    9: '回看',
    10: '當前非wifi環境',
    11: '暫無任何直播哦',
    12: '萬',
    13: '精彩推薦',
    14: '比賽欄目',
    15: '官方欄目',
    16: '點擊輸入內容搜索',
    17: '常見問題',
    18: '具體意見',
    19: '聯繫方式',
    20: '提交',
    21: '意見反饋',
    22: '取消',
    23: '收起',
    24: '請填寫反饋內容',
    25: '請重新登錄',
    26: '網絡故障請重新提交',
    27: '該反饋窗口僅針對直播或視頻的反饋，不包括遊戲內的問題。',

    //=============================
    28: '聊天',
    29: '評論',
    30: '競猜',
    31: '傳播違法低俗等不良信息將被禁言',
    32: '要屏蔽此人嗎',
    33: '如果您屏蔽此人，則獎無法看到其發佈的消息',
    34: '屏蔽',
    35: '已屏蔽 ${name}',
    36: '匿名發表',
    37: '查看更多',
    38: '隱藏評論',
    39: '查看${count}條回復',
    40: '自動賠率模式中賠率由系統實施計算',
    41: '${time} 後封盤',
    42: '已结束',
    43: '已封盤',
    44: '已投注',
    45: '投注',
    46: '我猜【${option}】',
    47: '請輸入投注數額',
    48: '暫未發起競猜',
    49: '投注截止時間已到，無法參與競猜',
    // 50: '不能重複投注',
    51: '點擊輸入內容',
    52: '内容を入力',
    53: '匿名發表',
    54: '發表${wait}',
    55: '點擊輸入搜索內容',
    56: '篩選',
    57: '已訂閱',
    58: '訂閱',
    59: '【戰報】',
    60: '展開',
    61: '已簽到',
    62: '簽到',
    63: '我的競猜',
    64: '我的訂閱',
    65: '我的關注',
    66: '兌換商城',
    67: '競猜記錄',
    68: '加載更多',
    69: '【我開：${option}】',
    70: '可領取',
    71: '您的競猜幣不足，無法投注',
    72: '獲得${value}競猜幣',
    73: '關注人數達到上限',
    74: '不能重複投注',
    75: '管理員信息',
    76: '打賞',
    77: '請輸入打賞數額',
    78: '打賞成功',
    79: '您的競猜幣不足，無法打賞主播',

    //-----------------------------------
    80: '榜單',
    81: '讚賞值',
    82: '主播周榜',
    83: '觀眾周榜',
    84: '按主播在全站一周內累計收穫競猜幣 的總數進行排名，玩家打賞主播的競 猜幣越多，主播獲得的讚賞值越高。',
    85: '按玩家在一周內累計打賞給主播的競 猜幣總數進行排名。',
    86: '暫無關注，赶紧去關注一波吧！',
    87: '暫無竞猜记录！',

    //=======================
    88: '沒有更多競猜記錄',
    89: '查看更多',
    90: '休息中',
    91: '直播中',
    92: '未開播',
    93: '倒計時結束可獲得${money}競猜幣',
    94: '請填寫正確的郵箱地址',

    //===================兑换记录-弹窗
    200: '兌換道具',
    201: '消耗逐夢券',
    202: '兌換時間',

    //===================领取竞猜币-弹窗
    205: '登錄遊戲',
    206: '參與1場排位賽',
    207: '與好友進行1場排位賽',
    208: '邀請您的朋友參加此活動',
    209: '分享活動信息',
    210: '領取競猜幣',
    211: '未完成',
    212: '領取',
    213: '已領取',
    215: '去分享',
    //===================顶部-领取竞猜币
    214: '領取競猜幣',

    //===================竞猜记录
    220: '總資產',
    221: '第${1}名',
    222: '回収率',
    223: '命中率',
    224: '【${1}】投入${2}張逐夢券',
    225: '待開獎...',
    226: '全部',
    227: '待開獎',
    228: '已開獎',
    229: '榜外',
    230: '最終結果：【${1}】，競猜幣${2}（實時賠率${3}）',
    231: '返回',

    //===================竞猜页
    235: '賠率',
    236: '本輪結果',
    237: '競猜已結束',
    238: '競 猜',
    239: '已投注',
    240: '已有${1}人參與',
    241: '確 認',
    242: '競猜',
    243: '競猜幣不足',
    245: '獲取競猜幣',
    246: '距離關閉競猜還有${1}日${2}時${3}分',
    247: '競猜開始時間：${1}日${2}時',
    248: '競猜尚未開始',
    249: '本競猜將於東京時間${1} ${2}開始',
    250: '今日',
    251: '${1}月${2}日',
    252: '請選擇下注對象',
    253: '下注成功！',
    254: '本場賽事將於${1} ${2}開始',
    255: '你已投注',
    256: '當前時間不能下注',
    257: '距離關閉競猜還有${1}時${2}分',//与246配对
    258: '問題',

    //==============排行榜
    260: '排名',
    261: '玩家',
    262: '回收率',
    263: '命中率',
    264: '總資產',
    265: '第${1}名',
    266: '競猜記錄',
    267: '我',
    268: '我的競猜記錄',
    269: '榜外',

    //===============兑换商城
    270: '限兌${1}/${2}次',
    271: '剩餘${1}份',
    272: '兌換',
    273: '兌換【${1}】',
    274: '確 定',
    275: '金幣不足',
    276: '兌換成功',
    277: '獎勵將在24小時內發放至您的郵箱',
    278: '當前時間無法兌換',
    279: '已兌完',
    280: '兌換失敗',
    281: '${1}月${2}日${3}開始兌換',
    282: '你已獲得競猜幣',


    //===============gamble
    290: '查看所有隊伍',
    291: '兌換記錄',
    292: '賽事競猜',
    293: '兌換商城',
    294: '競猜排行榜',
    295: '競猜記錄',
    296: '(${1}未開始)',
    297: '(${1}競猜中)',
    298: '(${1}直播中)',
    299: '(${1}已結束)',
    300: '競猜',//root顶部导航栏
    302: '確 定',
    303: '本屆CHAMP賽事已結束',
    304: '這場比賽的競猜將于MM月DD日HH：mm開始',

    301: '請選擇分享渠道',//分享渠道选择

    //===================竞猜页2
    400: '賽事信息',    
    401: '前往直播',
    402: '競猜TIPS'
  },
  jp: {
    1: '生放送',
    2: '動画',
    3: 'トーナメント',
    4: 'マイページ',
    5: 'フィードバック',
    6: '配信ページで、チャットしましょう',
    7: 'トーナメント',
    8: '人気実況者',
    9: '再視聴',
    10: 'Wi-Fi未接続のため、通信料が発生します',
    11: '只今、生放送はしてませんよ',
    12: '万',
    13: 'おすすめ',
    14: 'トーナメント',
    15: '公式コラム',
    16: '検索',
    17: 'よくある問題',
    18: '問題を説明してください',
    19: '連絡先',
    20: '提出する',
    21: 'フィードバック',
    22: 'キャンセル',
    23: '閉じる',
    24: 'フィードバックを記入してください',
    25: 'もう一度ログインしてください',
    26: 'ネットワークに接続できません，もう一度やり直してください',
    27: 'この「フィードバック」は実況センターの問題向けです。ゲーム内の問題は含まれていません。',
    //=============================
    28: 'チャット',
    29: 'コメント',
    30: '勝敗予想',
    31: '法律や公序良俗に反する場合、発言を禁止されます',
    32: 'このユーザーをブロックしますか',
    33: 'ブロックすると、このユーザーのメッセージを表示できなくなります。',
    34: 'ブロック',
    35: '${name} さんをブロックしました',
    36: '匿名ユーザー',
    37: 'もっと',
    38: '返信を非表示',
    39: '${count}件の返信を表示',
    40: 'オッズはシステムにより自動的に計算されます',
    41: '${time} 後受付終了',
    42: '終了',
    43: '受付終了',
    44: 'ベット済み',
    45: 'ベットをする',
    46: '【${option}】にかける',
    47: 'ベットするメダル数を入力',
    48: 'まだ勝敗予想がありません',
    49: 'ベット受付終了です',
    50: 'ベットを繰り返してはいけません',
    51: 'クリックで入力',
    52: '内容を入力',
    53: '匿名送信',
    54: '送信${wait}',
    55: 'クリックでキーワード検索',
    56: 'フィルタ',
    57: 'リマインダー：オン',
    58: 'リマインダーを設定',
    59: 'レポート',
    60: '続きを読む',
    61: '済み',
    62: 'チェックイン',
    63: '勝敗予想',
    64: 'リマインダー',
    65: '登録チャンネル',
    66: '引換ショップ',
    67: '過去の予想',
    68: 'もっと',
    69: '【${option}にかける】',
    70: '受け取れる',
    71: 'メダルが足りないので、ベットできません',
    72: 'メダル${value}を獲得',
    73: '登録チャンネル数が上限に達しました',
    74: 'ベットを繰り返してはいけません',
    75: '運営から',
    76: 'メダルを贈る',
    77: 'メダル数を入力',
    78: 'メダルを贈った',
    79: 'メダルが足りないので、贈ることはできません。',
    //-----------
    80: 'ランキング',
    81: '評価値',
    82: '実況者',
    83: 'プレイヤー',
    84: '実況者が1週間にもらったメダル数によってランク付けます。プレイヤーが贈ったメダルが多いほど、実況者が獲得した評価値が高い。',
    85: 'プレイヤーが1週間に実況者に贈ったメダル数によってランク付けます。',
    86: '登録チャンネルがありません。チャンネルを登録してきてくださいね。',
    87: '過去の予想はありません。',

    //=======================
    88: '他の予想はありません',
    89: 'もっと見る',
    90: '休憩中',
    91: '生配信中',
    92: '生配信していない',
    93: 'タイマー終了時は${money}メダルを受け取れる',

    //--------------------------
    94: '正しいメールアドレスをお願いします',


    //===================兑换记录-弹窗
    200: '引換アイテム',
    201: '使用した予想コイン',
    202: '引換期間',

    //===================领取竞猜币-弹窗
    205: 'ゲームにログイン',
    206: '通常バトルに参加',
    207: 'フレンドと一緒に通常バトルに参加',
    208: 'シェアしたリンクでフレンドを招待',
    209: 'イベント情報をシェア',
    210: '予想コイン',
    211: '未達成',
    212: '受け取る',
    213: '受取済み',
    215: 'シェア',
    //===================顶部-领取竞猜币
    214: '予想コインをゲット',

    //===================竞猜记录
    220: '総資産',
    221: '${1}位',
    222: '回収率',
    223: '的中率',
    224: '【${1}】予想コイン${2}枚使用',
    225: '結果待ち...',
    226: '全部',
    227: '結果待ち',
    228: '試合結果',
    229: 'ランク外',//'ランキング外'
    230: '試合結果：【${1}】，予想コイン${2}（当時オッズ${3}）',
    231: '戻る',

    //===================竞猜页
    235: 'オッズ',
    236: '試合結果',
    237: '本予想は終了しました',
    238: 'ベットする',
    239: 'ベット済み',
    240: '${1}人参加済',
    241: '確 認',
    242: '試合予想',
    243: '予想コインが不足しています',
    245: '今すぐゲットへ',
    246: 'ベット受付終了まで${1}日${2}時間${3}分',
    247: '予想開始時間：${1}日${2}時',
    248: '予想受付時間外',
    249: '本試合の予想は${1} ${2}から参加解禁です',
    250: '本日',
    251: '${1}月${2}日',
    252: 'ベットする選択肢を選んでください',
    253: 'ベット完了！',
    254: '本試合は${1} ${2}より開催しますので、是非ご期待ください！',
    255: 'ベット済みです、試合観戦を楽しんでください！',
    256: '現在ベットできません',
    257: 'ベット受付終了まで${1}時間${2}分',//与246配对
    258: 'クイズ',

    //==============排行榜
    260: 'ランキング',
    261: 'プレイヤー',
    262: '回収率',
    263: '的中率',
    264: '総資産',
    265: '${1}位',
    266: '予想記録',
    267: '私',
    268: '予想履歴',
    269: 'ランキング外',

    //===============兑换商城
    270: '残り${1}/${2}回',
    271: 'サーバー限定${1}個',
    272: '引換',
    273: '予想コインを使用して、【${1}】を引き換 えますか？',
    274: '確 認',
    275: '予想コインが不足しています',
    276: '引き換え完了！',
    277: '報酬は24時間以内にゲーム内メールボックスに送付します。',
    278: '現在引換できません',
    279: '引換制限数量となりました',
    280: '兌換失敗',
    281: '${1}月${2}日 ${3}から引換可能',
    282: '予想コインをゲットしました',

    //===============gamble
    290: '全チームを確認',
    291: '引換履歴',
    292: '試合予想',
    293: '引換ショップ',
    294: '予想ランキング',
    295: '予想履歴',
    296: '(${1}未開始)',
    297: '(${1}予想中)',
    298: '(${1}配信中)',
    299: '(${1}終了済)',
    300: '予想',//root顶部导航栏
    302: '確 認',
    303: '本大会は既に終了いたしました',
    304: '本試合の予想は${1}月${2}日${3}より開始します',

    301: 'イベント情報をシェア',//分享渠道选择

    //===================竞猜页2
    400: '大会情報',
    401: '観戦する',
    402: '予想ヒント'
  }
}








